import { Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { API, graphqlOperation } from "aws-amplify";

import { executedServiceOrdersByServiceOrderID } from "graphql/queries";
import { getUserEmail } from "graphql/custom-queries";
import ExecutedOrderItem from "./ExecutedOrderItem";

const ExecutedOrderCard = ({ serviceOrderID }) => {
  const [executedServiceOrder, setExecutedServiceOrder] = useState({
    data: [],
    loading: false,
  });

  async function fetchUser(id) {
    try {
      const userData = await API.graphql(
        graphqlOperation(getUserEmail, {
          id,
        })
      );
      const userItem = userData.data.getUser;
      return userItem?.email ?? "";
    } catch (err) {
      console.log("Error fetchUserName", err);
      return "";
    }
  }

  const getExecutedServiceOrderData = async (id) => {
    try {
      setExecutedServiceOrder({ data: {}, loading: true });

      const executedServiceOrdersData = await API.graphql(
        graphqlOperation(executedServiceOrdersByServiceOrderID, {
          serviceOrderID,
          id,
          filter: {
            deletedAt: { attributeExists: false },
            executionStartedAt: { attributeExists: true },
          },
        })
      );
      const executedServiceOrderItem =
        executedServiceOrdersData.data.executedServiceOrdersByServiceOrderID
          .items[0];

      if (!executedServiceOrderItem) return;

      const userExecutorName = await fetchUser(
        executedServiceOrderItem.userExecutor
      );

      setExecutedServiceOrder((prev) => ({
        ...prev,
        data: { ...executedServiceOrderItem, userExecutorName },
      }));
    } catch (err) {
      toast.error(strings.errors.fetchExecutedServiceOrder);
    } finally {
      setExecutedServiceOrder((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (serviceOrderID) getExecutedServiceOrderData(serviceOrderID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceOrderID]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">{strings.executionServiceOrder}</span>
        {executedServiceOrder.loading ? (
          <Loader />
        ) : (
          <Grid gap="5px">
            {executedServiceOrder.data.id ? (
              <ExecutedOrderItem item={executedServiceOrder.data} />
            ) : (
              strings.noExecutedServiceOrder
            )}
          </Grid>
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    executionServiceOrder: "Resumen de ejecución de la órden",
    errors: {
      fetchExecutedServiceOrder: "Error al consultar la orden ejecutada",
    },
    noExecutedServiceOrder: "No se ha realizado ninguna ejecución...",
  },
});

export default ExecutedOrderCard;
